<template>
<div v-if="feedbackStatus">
<div class="container container--narrow mgt-24" v-if="isCommon()">
	<div class="mdc-card pdt-10 pdb-10 pdl-24 pdr-24 ">
			<div class="d-flex align-items-center justify-content-between ">
					<div class="t-subtitle3 font-m  t-line-h-22">
						{{ $t("1393") }}
					</div>
					<button class="mdc-icon-button content-trigger mgr--12" @click="toggleCommentaryViewStatus()"  tabindex="0">
						<i class="material-icons t-headline12 t-color-bodyGrayA">{{ commentaryViewStatus ? "expand_less" : "expand_more" }}</i>
						</button>
			</div>
			<div class="detail-content w-full mgt-12 mgb-16" v-show="commentaryViewStatus">
					<div class="t-body1 font-r t-color-bodyGrayA t-line-h-26">
						<vue-mathjax :formula="commonFeedback" v-if="useMathjax"></vue-mathjax>
						<div v-else>
							{{ commonFeedback }}
						</div>
					</div>
			</div>
	</div>
</div>
<div class="mgt-50 pdb-50" v-if="stateQuestionButton()">
<button
	@click="moveQuestion()" @keypress="moveQuestion()" tabindex="0"
	class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8">
		<div class="mdc-button__ripple"></div>
		<span class="mdc-button__label t-body2 font-r">{{ $t("1394") }}</span>
</button>
<button class="mdc-button t-color-secondaryBtnText b-radius4" @click="moveIssue()" @keypress="moveIssue()" tabindex="0">
		<div class="mdc-button__ripple"></div>
		<span class="mdc-button__label t-body2 font-r">{{ $t("1394") }}</span>
</button>
</div>
<div class="mgt-50 correct-ans-all-type-details">
<div class="container container--narrow pdt-30">
<div v-if="isCorrect()">
	<div class="t-subtitle3 font-rn">
		{{ $t("1398") }}
	</div>
	<div class="t-body1 t-color-bodyGrayA t-line-h-26 pdt-8">
		<vue-mathjax :formula="strippedContent(correctFeedback)" v-if="useMathjax"></vue-mathjax>
		<div v-else>
			{{ strippedContent(correctFeedback) }}
		</div>
	</div>
</div>
<div v-if="isIncorrect()">
	<div class="t-subtitle3 font-rn">
		{{ $t("1402") }}
	</div>
	<div class="t-body1 t-color-bodyGrayA t-line-h-26 pdt-8">
		<vue-mathjax :formula="strippedContent(incorrectFeedback)" v-if="useMathjax"></vue-mathjax>
		<div v-else>
			{{ strippedContent(incorrectFeedback) }}
		</div>
	</div>
</div>
<div v-if="isVideo() && videoFeedback && videoFeedback.mp4">
	<div class="divider mgt-16 mgb-16"></div>
	<div class="t-subtitle3 font-rn">
			{{ $t("1399") }}
	</div>

	<div class="mgt-8 bg-white commentary-video b-radius4">
			<div
					class=" b-radius4 position-relative d-flex align-items-center justify-content-center">
					<video controlsList="nodownload" id="my-video" class="w-full" width="100%" height="440"
							controls >
							<source :src="videoFeedback.mp4" type="video/mp4">
							<!-- <p class="vjs-no-js">
									To view this video please enable JavaScript, and consider upgrading to a
									web browser that
									<a href="https://videojs.com/html5-video-support/" target="_blank">supports
											HTML5 video</a>
							</p> -->
					</video>

					<!-- <i class="material-icons position-absolute play-icon t-color-white font62 play-button-round"
							onclick="playPause('video1')">play_arrow</i> -->
			</div>
	</div>
</div>

	<div class="mgt-50 pdb-50" v-if="!stateQuestionButton()">
			<button
				@click="moveQuestion()" @keypress="moveQuestion()" tabindex="0"
				class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{ $t("1394") }}</span>
			</button>
			<button class="mdc-button t-color-secondaryBtnText b-radius4" @click="moveIssue()" @keypress="moveIssue()" tabindex="0">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{ $t("1395") }}</span>
			</button>
	</div>
</div>
</div>
</div>
</template>

<script>
/**
 * 문항별 피드백 공통 컴포넌트(question feedback common component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { examMixin } from "@/mixins/exam.js";
import {MDCRipple} from '@material/ripple'
export default {
	props: [
		"commonFeedback",
		"correctFeedback",
		"incorrectFeedback",
		"videoFeedback",
		"feedbackStatus",
		"correct",
		"questionId",
		"currentGroupIndex"
	],
	data() {
		return {
			commentaryViewStatus: true,
			useMathjax: false
		};
	},
	mixins: [examMixin],
	mounted() {
	//	console.log(this.videoFeedback, this.feedbackStatus, ' __videoFeedback')
		 this.setMaterialUi()
	},
	methods: {
		toggleCommentaryViewStatus() {
			this.commentaryViewStatus = !this.commentaryViewStatus;
		},

		strippedContent(contents) {
			let regex = /(<([^>]+)>)/gi;
			return contents.replace(regex, "");
		},

		stateQuestionButton() {
			return;
			!(this.correctFeedback && this.feedback.CORRECT) &&
				!(this.incorrectFeedback && this.feedback.INCORRECT) &&
				!(this.videoFeedback && this.feedback.SOLVE_VIDEO);
		},

		isCommon() {
			return this.commonFeedback && this.feedbackStatus.COMMON;
		},

		isCorrect() {
			return (
				this.correctFeedback && this.feedbackStatus.CORRECT && this.correct
			);
		},

		isIncorrect() {
			return (
				this.incorrectFeedback && this.feedbackStatus.INCORRECT && !this.correct
			);
		},

		isVideo() {
			return this.videoFeedback && this.feedbackStatus.SOLVE_VIDEO;
		},
		setMaterialUi() {
						const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
								let button = new MDCRipple.attachTo(el)
								return button
						})

				},
	},
};
</script>
